import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Button } from './Button';
import { Activity, ArrowRight } from 'lucide-react';

interface InteractiveCheckSectionProps {
    onStart: () => void;
}

const InteractiveCheckSection: React.FC<InteractiveCheckSectionProps> = ({ onStart }) => {
  return (
    <div className="bg-surface py-12">
        <SectionWrapper className="py-12 md:py-20">
            <div className="bg-white rounded-[2.5rem] border border-divider p-8 md:p-16 shadow-xl relative overflow-hidden group hover:shadow-2xl transition-all duration-500">
                <div className="absolute top-0 right-0 w-64 h-64 bg-accent/5 rounded-full -mr-32 -mt-32 blur-3xl group-hover:bg-accent/10 transition-colors"></div>
                
                <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
                    <div className="flex-1 text-center lg:text-left">
                        <h2 className="text-3xl md:text-5xl font-black mb-6 text-primary tracking-tight leading-tight">
                            Ist Ihre Baustelle aktuell ein Risiko?
                        </h2>
                        <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-2xl">
                            Machen Sie den schnellen Selbsttest. In weniger als 3 Minuten erhalten Sie eine fundierte Ersteinschätzung Ihres IT-Schutz-Levels – interaktiv, unverbindlich und direkt auf Basis Ihrer Projektdaten.
                        </p>
                        
                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <Button onClick={onStart} className="text-lg px-10 shadow-lg relative overflow-hidden group/btn font-black uppercase tracking-widest">
                                <span className="relative z-10 flex items-center gap-2">
                                    Jetzt Risiko-Check starten <ArrowRight className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
                                </span>
                            </Button>
                        </div>
                    </div>

                    <div className="w-full lg:w-[450px] shrink-0">
                        <div className="relative aspect-video lg:aspect-[4/3] bg-white rounded-2xl border border-divider overflow-hidden shadow-2xl">
                            <img 
                                src="https://rombus.ch/wp-content/uploads/2022/07/rombus_keyvisual_reinigung.jpg" 
                                alt="Professionelle Reinigung technischer Infrastruktur" 
                                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrapper>
    </div>
  );
};

export default InteractiveCheckSection;